import React, { useEffect, useRef, useState } from "react";
import { createBrowserRouter, Outlet, useNavigate } from "react-router-dom";

/* Common Components */
import Header from "../components/Header";
import Footer from "../components/Footer";

import HomePage from "../pages/HomePage";
import Blog from "../pages/Blog";
import BlogDetail from "../pages/BlogDetail";
import Properties from "../pages/Properties";
import HowItWorks from "../pages/HowItWorks";
import Contact from "../pages/Contact";
import LP from "../pages/LP/test/lp";

import ErrorPage from "../pages/ErrorPage";
import About from "../pages/About";
import Faq from "../pages/Faq";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsCondition from "../pages/TermsCondition";
import axios from "axios";
import mainContext from "../config/mainContext";
import { headersConfig, basicAuthConfig } from "../config/constants";
import LPThank from "../pages/LP/test/thankYou";
import LPThankPopup from "../pages/LP/test/thankYouPopup";
import LPV1 from "../pages/LP/test/lp_v2";
import LPV3 from "../pages/LP/test/lp_v3";
import LPThankV1 from "../pages/LP/test/thankYou_v2";
import LPThankV3 from "../pages/LP/test/thankYou_v3";
import LPThankPopupV1 from "../pages/LP/test/thankYouPopup_v2";
import LPThankPopupV3 from "../pages/LP/test/thankYouPopup_v3";
import LPLeadsLogin from "../pages/LP/test/LPLeadsLogin";
import LPLeads from "../pages/LP/test/LPLeads";

const { REACT_APP_EMAIL, REACT_APP_PASSWORD, REACT_APP_DEVICEID } = process.env;

const AppLayout = () => {
  const scrollToRef = useRef(null);
  const navigate = useNavigate();
  const [mainObj, setMainObj] = useState({
    appToken: null,
    apiLoad: false,
  });

  // console.log("Route Change");
  const tokenRequested = useRef(false);
  /* Login Api */
  const getToken = () => {

    // const storedToken = localStorage.getItem("sToken");
    // if (storedToken) {
    //   setMainObj({ appToken: storedToken, apiLoad: true });
    //   return;
    // }
    // if (tokenRequested.current) return;
    tokenRequested.current = true;
    let payload = {
      email: REACT_APP_EMAIL,
      password: REACT_APP_PASSWORD,
      deviceId: REACT_APP_DEVICEID,
      deviceToken: "string",
      deviceName:
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/119.0.0.0 Safari/537.36",
      browser: "Chrome",
      region: "Asia/Calcutta",
    };

    axios
      .post(`/main/slice/api/v1/user/login`, payload, {
        headers: {
          ...headersConfig,
          ...basicAuthConfig,
        },
      })
      .then((response) => {
        let token = response?.data?.data?.accessToken;
        // console.log(token);
        setMainObj({ appToken: token, apiLoad: true });

        // localStorage.setItem("sToken", token);
      })
      .catch((error) => {
        console.log(error);
        setMainObj({ appToken: null, apiLoad: false });
      });
  };
  /* Login Api end */

  const handleScroll = () => {
    scrollToRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    handleScroll();
    if (process.env.NODE_ENV !== "development" || !tokenRequested.current) {
      getToken();
    }
  }, []);

  return (
    <>
      <div ref={scrollToRef}>
        <mainContext.Provider value={mainObj}>
          <Header />
          <Outlet />
          <Footer />
        </mainContext.Provider>
      </div>
    </>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/about", element: <About /> },
      { path: "/blog", element: <Blog /> },
      { path: "/blog-detail/:blogId", element: <BlogDetail /> },
      { path: "/contact", element: <Contact /> },
      { path: "/how-it-works", element: <HowItWorks /> },
      { path: "/properties", element: <Properties /> },
      { path: "/faq", element: <Faq /> },
      { path: "/faq/:data", element: <Faq /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/terms-condition", element: <TermsCondition /> },
      { path: "*", element: <ErrorPage /> },
    ],
  },

  {
    path: "/campaign/dubai-properties-v1",
    element: <LP />,
  },
  {
    path: "/campaign/dubai-properties-v1/thankyou",
    element: <LPThank />,
  },
  {
    path: "/campaign/dubai-properties-v1/pop-up-thankyou",
    element: <LPThankPopup />,
  },
  {
    path: "/campaign/lp-leads-login",
    element: <LPLeadsLogin />,
  },
  {
    path: "/campaign/lp-leads",
    element: <LPLeads />,
  },
  { path: "/campaign/dubai-properties-v2", element: <LPV1 /> },
  { path: "/campaign/dubai-properties-v2/thankYou", element: <LPThankV1 /> },
  { path: "/campaign/dubai-properties-v2/pop-up-thankyou", element: <LPThankPopupV1 /> },
    { path: "/campaign/dubai-properties-v3", element: <LPV3 /> },
  { path: "/campaign/dubai-properties-v3/thankYou", element: <LPThankV3 /> },
  { path: "/campaign/dubai-properties-v3/pop-up-thankyou", element: <LPThankPopupV3 /> },
]);

export default appRouter;
